import global from '../../../config/global';

const baseURL = global.apisUrl + '/onboard';

export const ghgReportingURL = baseURL + '/ghg-reporting';

export const benchmarkURL = (id) => baseURL + `/benchmarks${id ? '/' + id : ''}`;

export const EIDRURL = baseURL + '/env-info';

export const sbtiURL = baseURL + '/sbti';

export const dataCollectionBaseURL = global.apisUrl + '/data-collection';

export const ghgEmissionActivitiesURL = dataCollectionBaseURL + '/ghg-emission-activities';

export const onboardAssetURL = (id) => dataCollectionBaseURL + `/onboard-energy-assets${id ? '/' + id : ''}`;
